import XAPPService from 'app/Core/services/XAPPService';
export const GET_EMPRESAPESSOA_FORMULARIO = '[EMPRESAPESSOAORCAMENTO APP] GET FORMULARIO';
export const GET_EMPRESAPESSOA_FORMULARIO_TEMPLATE = '[EMPRESAPESSOAORCAMENTO APP] GET FORMULARIO TEMPLATE';
export const OPEN_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG = '[EMPRESAPESSOAORCAMENTO APP] OPEN NEW FORMULARIO DIALOG';
export const CLOSE_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG = '[EMPRESAPESSOAORCAMENTO APP] CLOSE NEW FORMULARIO DIALOG';
export const OPEN_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG = '[EMPRESAPESSOAORCAMENTO APP] OPEN EDIT FORMULARIO DIALOG';
export const CLOSE_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG = '[EMPRESAPESSOAORCAMENTO APP] CLOSE EDIT FORMULARIO DIALOG';
export const GET_FORMULARIO_INDEX = '[EMPRESAPESSOAORCAMENTO APP] GET INDEX TEMPLATE';
export const REMOVE_EMPRESAPESSOA_FORMULARIO = '[EMPRESAPESSOAORCAMENTO APP] REMOVE FORMULARIO';
export const ADD_EMPRESAPESSOA_FORMULARIO = '[EMPRESAPESSOAORCAMENTO APP] ADD FORMULARIO';
export const EMPRESAPESSOA_FORMULARIO_WARNING = '[EMPRESAPESSOAORCAMENTO APP] EMPRESAPESSOA_FORMULARIO WARNING';
export const EMPRESAPESSOA_FORMULARIO_INFO = '[EMPRESAPESSOAORCAMENTO APP] EMPRESAPESSOA_FORMULARIO INFO';
export const EMPRESAPESSOA_FORMULARIO_ERROR = '[EMPRESAPESSOAORCAMENTO APP] EMPRESAPESSOA_FORMULARIO ERROR';

export const EmpresaPessoaOrcamentoListState =
    [
        'idpessoaformulario',
        'idpessoa',
        'tipo',
        'itens',
        'validadedescricao',
        'valortotaldescricao',
        'nome',
        'formulario',
        'statusregistro',
        'usrins',
        'usrupt',
        'datainsdescricao',
        'datauptdescricao',
    ];

const EmpresaPessoaOrcamentoAddState =
    [
        'idpessoa',
        'idparent',
        'tipo',
        'formulario',
    ];

const EmpresaPessoaOrcamentoUpdateState =
    [
        'formulario',
    ];

export function getTemplate(_AIDPessoa) {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction('pessoa', _AIDPessoa)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOA_FORMULARIO_TEMPLATE,
                        payload: { ...response, id: _AIDPessoa },
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    }
}

export function list(_AAction, _AParams, _AIDPessoa, _ATipo, _AIDProcesso) {
    return (dispatch) => {
        var AConditionsAND = [
            { "Campo": "idparent", "Operador": "=", "Valor": _AIDPessoa },
            { "Campo": "tipo", "Operador": "=", "Valor": _ATipo },
            { "Campo": "idtarefaprocesso", "Operador": "=", "Valor": _AIDProcesso }
        ];
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "EmpresaPessoaOrcamento", AActions, "spvwempresapessoaorcamento", EmpresaPessoaOrcamentoListState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOA_FORMULARIO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG
    }
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG
    }
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG,
        data
    }
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG
    }
}

export function save(_AValue, _AParams, _AIDPessoa, _ATipo, _AIDProcesso) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }]
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, EmpresaPessoaOrcamentoUpdateState);
        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, EmpresaPessoaOrcamentoAddState);
        }


        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOA_FORMULARIO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AIDPessoa, _ATipo, _AIDProcesso)))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOA_FORMULARIO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AIDPessoa, _ATipo, _AIDProcesso)))
                }
            }).catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}

export function remove(_AValue, _AParams, _AIDPessoa, _ATipo, _AIDProcesso) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", "EXCLUIR", "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: REMOVE_EMPRESAPESSOA_FORMULARIO
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams, _AIDPessoa, _ATipo, _AIDProcesso)))
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearFormulario() {
    return {
        type: GET_EMPRESAPESSOA_FORMULARIO,
        payload: null
    }
}

export function clearTemplate() {
    return {
        type: GET_EMPRESAPESSOA_FORMULARIO_TEMPLATE,
        payload: null
    }
}

export function gerarPedido(_AValue, _AParams) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "", "GERAR", _AValue, "", AConditionsAND, AConditionsOR);
        XAPPService.XappCustomAction(AActions, _AParams, "spgerarpedidobyorcamento", 'CUSTOM')
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOA_FORMULARIO_WARNING,
                            payload: response.warning
                        })
                    ])
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOA_FORMULARIO_INFO,
                            payload: response.info,
                            novopedido: new Date().getTime()
                        })
                    ])
                }
            }).catch(error => {
                return dispatch({
                    type: EMPRESAPESSOA_FORMULARIO_ERROR,
                    payload: error
                });
            });
    };
}